import React, { useState } from "react";
import MenuItem from "./MenuItem";

const ShopMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menusList = [
    {
        id: 1,
      label: "Pack Shop",
      url: "/pack-shop",
    },
    {
      id: 2,
      label: "Booster Shop",
      url: "/booster-shop",
    },
    // {
    //   id: 3,
    //   label: "WUFF Zone",
    //   url: "/wuffy",
    // },
    {
      id: 4,
      label: "Market",
      url: "/market",
    },
    {
      id: 5,
      label: "Drops",
      url: "/drops",
    },
    {
      id: 6,
      label: "Bridge",
      url: "https://bridge.mycloudwallet.com/token-bridge/swap",
      external: true, 
    }
    
  ];


  const handleItemClick = () => {
    setIsOpen(false);
  };

  const handleMenuClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="">
      <div onClick={handleMenuClick}>
        <MenuItem text={"Shop"} noLink />
      </div>
      <ul className={`ml-6 ${isOpen ? "block" : "hidden"}`}>
        {menusList.map((item) => (
          <li key={item.id}>
            <MenuItem text={item.label} url={item.url} onClick={handleItemClick} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ShopMenu;
